module.exports = __webpack_public_path__ + "img/calendar@2x.d376ad9.jpg";